/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
import type { CreateScorecardResponseData } from './CreateScorecardResponseData.js';
import {
    CreateScorecardResponseDataFromJSON,
    CreateScorecardResponseDataFromJSONTyped,
    CreateScorecardResponseDataToJSON,
} from './CreateScorecardResponseData.js';

/**
 * 
 * @export
 * @interface CreateScorecardResponse
 */
export interface CreateScorecardResponse {
    /**
     * 
     * @type {CreateScorecardResponseData}
     * @memberof CreateScorecardResponse
     */
    data?: CreateScorecardResponseData;
    /**
     * 
     * @type {number}
     * @memberof CreateScorecardResponse
     */
    totalRecords?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateScorecardResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateScorecardResponse
     */
    pages?: number;
    /**
     * 
     * @type {Array<Error>}
     * @memberof CreateScorecardResponse
     */
    errors?: Array<Error>;
}

/**
 * Check if a given object implements the CreateScorecardResponse interface.
 */
export function instanceOfCreateScorecardResponse(value: object): boolean {
    return true;
}

export function CreateScorecardResponseFromJSON(json: any): CreateScorecardResponse {
    return CreateScorecardResponseFromJSONTyped(json, false);
}

export function CreateScorecardResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateScorecardResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : CreateScorecardResponseDataFromJSON(json['data']),
        'totalRecords': json['totalRecords'] == null ? undefined : json['totalRecords'],
        'page': json['page'] == null ? undefined : json['page'],
        'pages': json['pages'] == null ? undefined : json['pages'],
        'errors': json['errors'] == null ? undefined : json['errors'],
    };
}

export function CreateScorecardResponseToJSON(value?: CreateScorecardResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'data': CreateScorecardResponseDataToJSON(value['data']),
        'totalRecords': value['totalRecords'],
        'page': value['page'],
        'pages': value['pages'],
        'errors': value['errors'],
    };
}

